import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OktaInitializerService } from './okta-initializer.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [OktaInitializerService],
})
export class AuthenticationModule {}
